import {useCallback, useEffect, useRef, useState} from "react"
import {loadSolrResults} from "../../services/solr.service.js"
import {NewsroomResult} from "./NewsroomResult.jsx"
import {getTranslations} from "../../services/language.service.js";


export const NewsroomSearch = () => {
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState({})
    const [items, setItems] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const container = useRef(null);
    const LANG = getTranslations()

    const mapResults = {
        tags: (element) => {
            const tags = []

            for (const e of element.children) {
                tags.push(e.textContent)
            }

            return tags
        },
        content: 'string',
        teaser: 'string',
        title: 'string',
        url: 'string',
        image: 'string',
        category: 'string',
        readingTime: 'string',
        publishedAt: 'string',
        score: 'number',
        locked: 'boolean',
        stickyNews: 'boolean',
        userRoles: (element) => {
            const userRoles = []

            if (element === undefined) {
                return userRoles
            }

            for (const e of element.children) {
                userRoles.push(e.textContent)
            }

            return userRoles
        },
        loginUrl: 'string'
    }

    useEffect(() => {
        document.addEventListener('filter', (e) => {
            setFilter(e.detail)
            setCurrentPage(1);
            setItems([])
            setHasMore(true)
        })

        document.addEventListener('search', (e) => {
            setSearch(e.detail)
            setCurrentPage(1);
            setItems([])
            setHasMore(true)
        })

        document.addEventListener('reset', () => {
            setSearch('')
            setCurrentPage(1);
            setItems([])
            setHasMore(true)
            loadResponse()
        })
    },[])

    useEffect(() => {
        setIsLoading(true);
        loadResponse()
    }, [search, filter]);

    useEffect(() => {
        setIsLoading(true);
    }, []);

    const loadNextItems = useCallback(async () => {
        if (isLoading) return;

        setIsLoading(true);

        loadResponse()
    }, [currentPage, isLoading]);

    const loadResponse = () => {
        if (!hasMore) {
            return
        }

        const solrParams = {
            q: search === '' ? '*' : search.replace('*', ''),
            page: currentPage
        }

        const filters = {
            ...filter,
            type: '10'
        }

        loadSolrResults(solrParams, filters, mapResults).then((response) => {
            setItems((prevItems) => [...prevItems, ...response.results]);
            setCurrentPage((prevIndex) => prevIndex + 1);
            if (!response.hasMore) {
                setHasMore(false)
            }
            document.dispatchEvent(new CustomEvent('facets', {
                detail: response.facets
            }))
            setIsLoading(false)
        })
    }

    useEffect(() => {
        const handleScroll = () => {
            const {clientHeight} =
                document.documentElement;
            const {top, height} =
                container.current.getBoundingClientRect();
            if (top + height - clientHeight < 400) {
                void loadNextItems();

            }
        };
        if (hasMore) {
            window.addEventListener("scroll", handleScroll);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [loadNextItems]);

    return (
        <div ref={container} className="infinite-scroll-container">
            {items.map(result => <NewsroomResult result={result}></NewsroomResult>)}
            {(items.length < 1 && !isLoading) && <p>{LANG.noResults}</p>}
            {isLoading && <span className="loader"></span>}
        </div>
    )

}
